import * as React from 'react';
import { useTranslation } from 'react-i18next';

import notFound from '@/assets/not-found.png';
import { PAYMENTS_FRONTEND_URL } from '@/config';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[700px] w-full text-center">
      <div className="max-w-lg m-auto pt-16">
        <img width="252" alt="Not found - 404" src={notFound} className="block mx-auto mb-7" />
        <p className="text-5xl font-thin text-md-blue mb-14">{t('NotFound.title')}</p>
        <p className="my-8 font-secondary text-lg font-normal leading-normal text-md-black">
          {t('NotFound.description')}
        </p>
        <a
          title={t('NotFound.back')}
          href={PAYMENTS_FRONTEND_URL}
          className="underline hover:no-underline text-md-realBlack hover:text-md-realBlack font-secondary text-lg"
        >
          {t('NotFound.back')}
        </a>
      </div>
    </div>
  );
};
